export const environment = {
  // BaseUrl: "https://overfoodproject.s3.ap-southeast-1.amazonaws.com/", // TESTING ENVIRONMENT
  // apiUrl: "https://fxk6vwlqgb.execute-api.ap-southeast-1.amazonaws.com/test/", // TESTING ENVIRONMENT

  // BaseUrl: "https://overfoodproject.s3.ap-southeast-1.amazonaws.com/", // Staging ENVIRONMENT
  // apiUrl: "https://kncl9yd4f3.execute-api.ap-southeast-1.amazonaws.com/stage/", // Staging ENVIRONMENT

  BaseUrl: "https://overfoodproject.s3.ap-southeast-1.amazonaws.com/", // DEV ENVIRONMENT
  apiUrl: "https://f8gjnuu32i.execute-api.ap-southeast-1.amazonaws.com/dev/", // DEV ENVIRONMENT
  production: false
};
